import { observer } from 'mobx-react-lite';

import { useMeetingDebugInputDeviceRecorder } from '@/features/meeting-debug/meeting-debug.hooks';

import { useMeetingIntentPrompt } from './meeting-intent-prompt.hooks';
import {
  useMeetingParticipantSync,
  useMeetingSpeakerNameSync,
} from './meetings-participants.hooks';
import { useMeetingSegmentSwitchPrompt } from './meetings-segmentation.hooks';
import {
  useAutoStopActiveMeeting,
  useContextKitCrashRecovery,
  useMeetingAppDetection,
  useMeetingHeartbeat,
  useMeetingHotkey,
  useMeetingInputDeviceConnectedNotification,
  useMeetingInterrupt,
  useMeetingNewEventStartedPrompt,
} from './meetings.hooks';
import { meetingStore } from './meetings.state';

/**
 * Invisible component that runs global meeting-related effects.
 * - Auto-stops meetings after inactivity timeout
 * - Detects when meeting apps are opened/closed
 * - Handles mod+l hotkey for start/stop/resume
 * - Prompts to move a recording when the browser changes meeting room
 */
export const MeetingGlobalEffects = observer(function MeetingGlobalEffects() {
  const recordingMeetingId =
    meetingStore.asRecordingOrStoppingMeeting?.meetingId;

  useAutoStopActiveMeeting(recordingMeetingId);
  useContextKitCrashRecovery();
  useMeetingAppDetection();
  useMeetingHeartbeat();
  useMeetingHotkey();
  useMeetingInputDeviceConnectedNotification();
  useMeetingIntentPrompt();
  useMeetingInterrupt();
  useMeetingNewEventStartedPrompt();
  useMeetingParticipantSync();
  useMeetingSegmentSwitchPrompt();
  useMeetingSpeakerNameSync();
  useMeetingDebugInputDeviceRecorder();

  return null;
});
